import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconControllerButtonTriangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconControllerButtonTriangle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M12.0003 7.5L16.614 15.125H7.38672L12.0003 7.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconControllerButtonTriangle;
